var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4997d0",
    d: "M.3 0h53.4v40H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.1 0H36v40H18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1 25.3h.4m.2-.4.2.3m-.6-.3.2.3m-3.3-9.4-.3.2m0 0v-.3m-.2.3v.2m.2 0h-.1m-.3 0v.5m-.1 0 .1.1m-.3.5v.2m.3-.3-.1.1m.1.3-.2.2m-.3 2.7q0 .3.3.4m0 0h-.2m.3.9.3.3m-.1.2h.2m.1-.2v.3m.3.4v.3m2.7 1.9-.1.1m-.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "m27.4 25.8-.2-.1q-.7-.4-1.6-.5-.3 0-.4-.3-.6-.1-1-.4H24l-.5-.4q-1-.7-1.5-1.8-.8-1.2-.8-2.7l.1-1.9q.3-1.4 1-2.5-.8 1.2-1 2.6l-.2 1.8q.1 1.6.8 2.8.6 1 1.5 1.8.3 0 .5.3l.1.1 1 .4.5.2q.7.1 1.6.5l.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.4 25.8-.2-.1q-.7-.4-1.6-.5-.3 0-.4-.3-.6-.1-1-.4H24l-.5-.4q-1-.7-1.5-1.8-.8-1.2-.8-2.7l.1-1.9q.3-1.4 1-2.5-.8 1.2-1 2.6l-.2 1.8q.1 1.6.8 2.8.6 1 1.5 1.8.3 0 .5.3l.1.1 1 .4.5.2q.7.1 1.6.5l.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#67923d",
    d: "M22 22.2q-.2-.9 0-1.6.6 1.4 0 1.6m3.1 3.1q-.8.2-1.5.8 1.7-.2 1.5-.8m.5-.3q-.7-.7-1-1.8c1.1.7 1.4 1.6 1 1.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#67923d",
    d: "M25.3 25q-.8-.6-1.1-1.6 1.5 1.1 1 1.6m-1-.5c0-.5-.4-1.6-.6-1.8q-.1 2 .5 1.8m-2-1.6.1-1.5q.4 1.3 0 1.5m-.8-5.3q.5-.8 1.4-1.1-1 1.5-1.4 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#67923d",
    d: "M21.5 17.2q.4-.9 1.2-1.4c-.3 1-1 1.6-1.2 1.4m1.9 6.8q-.5-.8-.5-1.8 1 1.5.5 1.8m-2-2.5a3 3 0 0 1-1.5-.4q1.6-.2 1.6.4m-.1-.7c0-.3.6-1 .7-1.1 0 .8-.5 1.3-.7 1.1m3.5 4q-1 .3-1.8 1 2-.2 1.8-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M22 22.2q.6-.2 0-1.6zm.8 1.3q-.7-.5-1.5-.7c.6.8 1.4 1 1.5.7M21 20a4 4 0 0 0-1-1.7c.1 1.2.8 1.9 1 1.7m.6 2.4-1.4-.4q1.2.8 1.4.4m-.6-1.8q-.4-.6-1.2-1 .7 1.5 1.2 1m.2-3.2c0-.6-.4-1.6-.5-1.8q-.1 1.8.4 1.8m.3-1v-1.7q-.6 1.5 0 1.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M21.9 15.7q.3-.6.2-1.3c-.5.6-.4 1.3-.2 1.3m.4-.4.6-1.2q-.9.8-.6 1.2m-1 3-.8-1.3q.2 1.5.7 1.3m2.1 5.9q-.8-.5-1.7-.4c.8.7 1.7.7 1.7.4m.8.3q-.6 0-.5-1.8zm1 .8q0 .6-1.5.8zm.4-.3q.6-.4-1-1.8 1 1.5 1 1.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M25.3 25q.5-.5-1.1-1.6 1 1.3 1 1.6m-3-2.1q.6-.1.1-1.5zm-.8-5.3c.2.2 1-.1 1.4-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M21.5 17.2c.3.2 1-.3 1.2-1.4q-.9 1.3-1.2 1.4m1.9 6.8c.3 0 .3-1-.5-1.8zm-2-2.5q0-.6-1.5-.4zm0-.7q.3.2.6-1.1zm3.4 4q0 .8-1.8 1 1.6-.6 1.8-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M21.6 21.8a3 3 0 0 0-1.2-1c.3.9 1 1.2 1.2 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#67923d",
    d: "M21 18.2c.4-.3 1.3-.6 1.4-.6q-1 1-1.3.6m1.8 5.3c-.1.3-.9.1-1.5-.7q.8.5 1.5.7M21 20q-.6.2-1-1.7zm.6 2.4q-.2.4-1.4-.4zm-.6-1.8q-.4.5-1.2-1 .9 1 1.2 1m.1-3.2q-.6 0-.5-1.8zm.3-1q-.4-.2 0-1.7zm.4-.6q-.4-.2.2-1.3zm.4-.4q-.3-.3.6-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#67923d",
    d: "M21.2 18.3q-.5.2-.7-1.3zm2.2 5.9c0 .3-.9.3-1.7-.4zm-.5-.7q-.5-.6-.5-1.3.9 1 .5 1.3m-1.2-1.7a3 3 0 0 1-.2-1.6q.8 1.4.2 1.6m-.2 0c-.1.2-.8-.1-1.1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M21 18.2q.5.4 1.4-.6-1.1.8-1.3.6m.7 3.6q.6-.2-.2-1.6.2.7.2 1.6m1.2 1.7q.4-.2-.5-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M21.2 19.4a3 3 0 0 0-.3-1.7q-.3 1.7.3 1.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#67923d",
    d: "M21.2 19.6q-.7-.2-.3-1.9 0 1.6.3 1.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#67923d",
    d: "M21.1 19.6q0-1 .6-1.7 0 1.7-.6 1.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M21.1 19.6q.6-.1.6-1.7-.4 1.5-.6 1.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#67923d",
    d: "M21.2 20.2q0-.9.7-1.6-.1 1.8-.7 1.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M21.2 20.2q.7.2.7-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ba1f3e",
    d: "M21.4 16.7v-.1zm.6-.4V16l-.1.1M21 21l.2-.1H21m.3-1v-.2h-.1zm.8 2.6.1-.1v-.1H22zm-.3.1h-.1m3.1 2.1h-.1zm.2.5V25l-.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.5 17.2.1.1m-.4-1.3v-.3m.2.2-.1.3m-.3 0 .4.3m.2 0v.5m-.1.7.2.3m0-.1.1-.2m.2 2.2-.2.2m-.3 0 .2.3m.2.4-.3.3m0 .3-.3.3m-.7 1.1v.4m.3-.6v.2m.3 0H32m-1.2 1.5h-.3m-.4.4-.2-.1m-1 .2-.2.3m0-.4-.3.4m.2.2-.4-.1m1.2 0-.5-.1m.7 0h-.7m.1.1-.2-.1m4-3.4q-.2 0-.3.3m0-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "m26.6 25.8.2-.1q.8-.4 1.7-.5l.4-.3 1-.4h.2q.1-.3.5-.4.9-.7 1.4-1.8.8-1.2.8-2.7v-1.9q-.4-1.3-1.1-2.5 1 1.2 1.1 2.6l.1 1.8q-.1 1.6-.8 2.8-.5 1-1.4 1.8-.3 0-.5.3l-.2.1-1 .4-.4.2q-.9.1-1.7.5l-.2.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M32 22.4c.2-.5 0-1.7-.1-1.9-.5 1-.2 2 0 1.9m-.4.5v-1.5q-.5 1.3 0 1.5m1.1-5.1q-.4-.7-1.3-1 1 1.3 1.3 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "m32.5 17.2-1-1.1q.6 1.3 1 1.1m.4 1-1.2-.5q.8 1 1.2.5m-.2 3.2q.7 0 1.3-.4-1.3-.1-1.3.4m0-.4c0-.4-.5-1.1-.6-1.2q.1 1.3.5 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M32.7 20q-.2-.7-.7-1.5.1 1.6.7 1.6M29 25.4q.7.6 1.5.7c-.6-.8-1.4-1-1.5-.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#67923d",
    d: "M32 22.4q-.7-.1-.1-1.9zm-3.6 3q.8.2 1.4.8-1.6-.2-1.4-.8m0-.6c.1-.5 1-1.4 1.2-1.5-.3 1.2-1 1.8-1.2 1.5m1.4-.3q0-.9.5-1.8.1 2-.5 1.8m1.5-1q.6-.5 1.4-.7-1 1.2-1.4.7M33 20c0-.5.7-1.3.8-1.3q-.3 1.4-.8 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#67923d",
    d: "M32.2 22.5Q33 22 34 22q-1.4 1-1.7.4m.7-1.7a3 3 0 0 1 1.2-1q-.7 1.3-1.2 1m-.1-3.1c0-.6.5-1.6.7-1.7q-.1 1.8-.7 1.7m-.5-1.8v-1.4q.5 1.2 0 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#67923d",
    d: "m32 15.7-.7-1.5c.8.6 1 1.4.7 1.5m.8 2.4q-.1-.1 1-1-.5 1.4-1 1m-2.3 6.2a4 4 0 0 1 2-.5q-1.7 1.2-2 .5m1-1.4q-.5-.1 0-1.5zm1.1-5.1q-.4.3-1.3-1zm0-.6q-.6.3-1-1.1.6 1 1 1.1m.3 1q-.3.4-1.2-.5 1 .6 1.2.5m-.2 3.2c-.1-.2.5-.6 1.3-.4q-.6 0-1.3.4m0-.4q-.5 0-.6-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#67923d",
    d: "M32.7 20.1c-.3.2-.8-.5-.7-1.6zM29 25.3c.1-.3.9-.1 1.5.7q-1.2-.7-1.5-.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M29.8 24.5q.6 0 .5-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M30.5 24.2q.4-1 .3-1.9-.9 1.6-.3 1.9m-2.1 1.2q-.2.6 1.4.8zm0-.6c.2.2 1-.3 1.2-1.5zm2.9-1.3c0 .3.8.1 1.4-.7zM33 20q.5.1.8-1.3zm-.8 2.6c0 .3.9.3 1.7-.4zm.7-1.7q.5.3 1.2-1zm0-3.1c.2 0 .7-.6.6-1.7zm-.6-1.8q.5-.2 0-1.4zm-.2-.2c.2-.1 0-.9-.7-1.5zm.7 2.4q.5.4 1-1zm-2.3 6.2q.3.7 2-.5-1.7.6-2 .5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M31 23.8q.3-.8.2-1.4-.6 1.2-.2 1.4m1.3-2a3 3 0 0 0 .2-1.6q-.7 1.4-.2 1.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#67923d",
    d: "M30.5 24.2c-.3 0-.4-1 .3-1.9q-.4 1.6-.3 1.9m2.4-4.7q.1-1.1.4-1.6c.2 1-.2 1.7-.4 1.6M31 23.8q-.4-.2.2-1.4zm1.6-7.2V15q.5 1.4 0 1.5m-4 8.3c.2-.6 1.1-1.5 1.3-1.6-.3 1.2-1 1.8-1.2 1.6m3.7-3a3 3 0 0 1 1.2-1q-.7 1.5-1.2 1m0-.1q-.5-.2.2-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M32.9 19.6q.6 0 .4-1.7 0 1-.4 1.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M33 19.6c0-.6-.5-1.6-.7-1.7q0 1.7.6 1.7m-.4-3q.5-.2 0-1.5zm-4 8.2q.7.4 1.3-1.5zm3.8-2.8c.1.2.8-.2 1.1-1.1q-.5.6-1.1 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#67923d",
    d: "M33 19.5q-.7.1-.7-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ba1f3e",
    d: "m32.7 17 .1-.1h-.2zm.3.8v-.2zm0 2.6.2-.1-.1-.1H33zm-.3-.5h.1v-.2zm-1 2.7h.1v-.1zm.5.2v-.1H32zM29.3 25v-.1zm-.5.4h.1v-.2zm3.4-8.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c959d",
    d: "M24 22.5v.1a.1.1 0 0 1 0-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c959d",
    d: "M24.1 22.6q-.1.2-.2 0h-.1v.2zv-.3l-.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#485654",
    d: "M24.1 22.6h-.2v-.1h-.1v.1zl.1-.1v-.2l-.1-.1v.3m0 0v-.3l.1.1v.2l-.1.1h-.3v-.1l.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6c301e",
    d: "m29.4 16.5-2.7 2.7-2.8 2.7-.3.4-.5.5-.1.1-.4.3-.8 1 .4.7h.2l1-1.4.4-.9.8-.8v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c959d",
    d: "m23.8 22-.2-.2h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b6ba",
    d: "m32.2 14.5-2.1 1.8H30l-.2-.2.1-.1h-.1l-.2.1-3.7 3.7-1.5 1.5-.5.3v.1l-.2.4-.2.3.3.2.7-.8v-.2h-.1v-.1l5.3-5.3.2.2h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#485654",
    d: "M23.7 22h.1v-.3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2 22v-.1m-.2.3h-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#485654",
    d: "M24.4 21.5h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c959d",
    d: "m28.5 17.2.2.2zm.5 5.4-.2.1za.1.1 0 0 0 0-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c959d",
    d: "M28.8 22.7q0 .2.2 0h.1l-.1.2-.3-.2v-.2l.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#485654",
    d: "m28.8 22.7.1.1h.1v-.1h.1v.1h-.3zv-.1l.1-.1v.2zm0 0v-.3h-.1v.3l.1.1h.3v-.1H29v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6c301e",
    d: "m23.8 16.3 2.6 2.9L29 22l.3.4.5.6.4.4.8 1-.5.6q0 .2-.2 0l-.9-1.4-.3-.9-.7-.9h-.1v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c959d",
    d: "M29.2 22h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b6ba",
    d: "m21 14.2 2.1 1.9h.1l.2-.2v-.1h.1v.1l3.6 4 1.5 1.5.4.3.1.1.1.4.2.3-.3.2-.7-.8.1-.3-5-5.6-.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#485654",
    d: "M29.2 22.2V22l-.1-.2v.4zm-.6-.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c959d",
    d: "m24.6 17-.2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#67923d",
    d: "M23.9 24.5q-1-.2-2 0 1.8.8 2 0m6 .2c.5-.2 1.8 0 2 0q-1.8.8-2 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M23.9 24.5q-.2.8-2 0zm6 .2q.2.8 2 0-1.7.2-2 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b6ba",
    d: "M29 24.1q-2.1-2.9-5.2-4.7l1 .5q2.4 1.6 4.4 4 0 .2-.2.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c959d",
    d: "M29 24.1c-1.6-2-3.8-3.9-5.2-4.7 2 1 3.7 3 5.3 4.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#485654",
    d: "M29 24.1a21 21 0 0 0-5.2-4.7l1.5 1a14 14 0 0 1 2.6 2.4zm0 0-3.7-3.7-1.5-1 1.5 1a19 19 0 0 1 3.7 3.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fab81c",
    d: "m29.5 23.8-.3.1-.3.3h-.2l.1.2h.3l.8.7q.2 0 .1-.2.2-.3 0-.7t-.5-.4m.5.3v.1q.1.4-.1.6l-.1-.1-.1-.2h-.1l-.1-.2h-.1V24l.2-.2q.3 0 .4.2m-.2.2V24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fab81c",
    d: "M30 24.1h-.1q0-.2 0 0zm-.9.3q0-.3.3-.3Zm0 0 .3-.2Zm.1 0h.3Zm.1.2q.2 0 .3-.2Zm.1.1q.2 0 .3-.2Zm.1.1.3-.1Zm.1.1.3-.1Zm.1.1.3-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6c301e",
    d: "m29.1 24.4.2-.2zm0 0h.1l.1-.1h-.2m.1 0h.2zm.1.2h.2v-.1zm.1.1h.2v-.2.1zm.1.1h.2v-.1zm.1.1h.2v-.1zm.1.1h.2v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b6ba",
    d: "M24.8 24q2.2-2.9 5.4-4.4l-1 .3a22 22 0 0 0-4.6 3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#485654",
    d: "M24.7 24a21 21 0 0 1 5.5-4.4l-1.5.8a14 14 0 0 0-2.7 2.2zm0 0 4-3.6 1.5-.8-1.5.9a19 19 0 0 0-4 3.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fab81c",
    d: "m24.2 23.6.4.1.2.3h.2v.2l-.2.1-.2-.1-.8.7q-.2 0-.1-.2v-.1q-.2-.3 0-.7t.5-.3m-.4.3q-.2.5 0 .6h.2v-.2h.2V24h.2v-.2l-.2-.2q-.3 0-.4.2m-.1.2q0-.2 0 0m.1 0v-.1zm0-.1v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fab81c",
    d: "M24 23.8h-.1q0 .2 0 0m.7.4q0-.2-.2-.3Zm0 0-.2-.2Zm0 0h-.3Zm-.2.2-.2-.2Zm0 0H24Zm-.2.2q-.2 0-.2-.2Zm-.1 0h-.2Zm-.1.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6c301e",
    d: "m24.6 24.2-.1-.2zm0 0h-.1l-.1-.1zm0 0h-.3.2m-.2.2h-.1v-.1h-.1zm0 0H24h.2m-.2.2-.2-.1zm-.1 0h-.2zm-.1.2h-.1l-.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M22.2 15.9q.9-.5 1.3-1.3-1.6.7-1.3 1.3m9.9.3q-.4-.9-1-1.4.4 1.6 1 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#67923d",
    d: "M22.2 15.9q-.2-.7 1.3-1.3zm9.9.3q-.6.3-1-1.4.7 1.3 1 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M25.1 21.2q-.2.1-.5-.5c-.1-.6.3-.7.3-.7h1v1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M25.2 21q-.1.2-.3-.3l.1-.4.6.1v.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M25 20.3h.6l.1.4h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M25 20s.4-.1.5.5q0 .3-.3.6l1-.1-.2-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9f0aa",
    d: "M25.1 21.2 29 21c1-.6 0-3-1-4.2.2-.3-2-1-2.9-1l-.3.1c-.6 0-.6.7-.4 1.2.3.4 2.1 3.8.8 4.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "m28.9 18.2-.8-1.4c0-.3-2-1-3-1l-.3.1c-.6 0-.6.7-.4 1.2l.6 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.9 18.2-.8-1.4c0-.3-2-1-3-1l-.3.1c-.6 0-.6.7-.4 1.2l.6 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M25.3 19q.8 1.7-.1 2.2L29 21q.8-.6.2-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3 19q.8 1.7-.1 2.2L29 21q.8-.6.2-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M24.8 16.1q-.4.1-.3.4.2.5.3.4h.4l.2-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M24.8 16.1h.6v.6H25s.2-.5-.1-.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M28 16.8c.5 0 .5-.7.2-1l-3.4.1q.3-.1.5.5l-.2.4-.3.1h.4c1.5-.2 2.9-.1 2.9-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b07e09",
    d: "M25.5 17.7h.1l.1.2v.1h.2-.3zm.4 0h-.1zl.1.2.1.1H26zm.3.2h.1zm-.1-.2H26zv.1h.1v.2H26zm.5-.1h-.1v.2h.1v.1h.1-.2v-.2h-.1v-.1zm.1 0h.2v.1l.2.2H27v-.1h-.1v.1h-.1zm.1.1h.1zm.5.2h.1zl-.1-.3H27h.3zm.3-.1h-.1v-.4l.3.4zm0 0v-.2zm.3-.2q.2 0 .2.2l-.2.1q-.2 0 0 0zm.1.2v-.1l-.1-.1zm-1.4.9v-.3h-.1zm0-.3h.2zl.2.2v.1h-.2.1v-.1h-.1zm.5 0H27zh.1q.2 0 .2.2l-.2.1zm.1.2h.1v-.1l-.1-.1zm.5-.3h-.2v.2h.2-.1v.1h.2-.2l-.1-.2h-.1zm-1.9 1 .2.1v.1h.1zh.1v.1m.5-.1H26v.1h.1l.1.1h-.1v.1h.2-.2l-.1-.2-.1-.1zm.2.3h.1zv-.3h-.1.2v.3m.4-.1.1.1zv-.2H27h.3-.1zm.2-.2H27zl.1.2v.1H27v-.3m.4-.1h-.2v.2h.2-.1v.1h.2-.2l-.1-.2h-.1zm0 0h.1l.2.3V19h.1l.1.3h-.1v-.2.2l-.3-.2.1.2zm.7.1V19zm-.1 0V19h.3v.2q.1 0 0 .1zm.3 0V19h.2v.1l.1.1v.1l-.1-.1v.1zm.1 0V19h-.1zm.5-.2h-.1v.1zh-.1v.2h.2-.2l-.1-.3zm-2.2 1V20h-.1.2l.2.1v.2h-.3zm0 .1h.2V20l-.1-.1zm.6-.3h-.2zv.2h.1l-.2.1V20H27zm.4.3h-.1V20h-.1l.1-.1zm.3 0V20zm0 0V20l-.1-.1v-.1a.1.1 0 0 1 .2 0v.2m.3 0h-.1v-.3.1h-.1v-.1h.2v.1l-.1.2m.2 0v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "m26.7 14.4-.2.4q-.2.5.5.8t1 .1l-.8-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#448127",
    d: "m28.6 23.7-.1-.1q-1 1.1-2.2 2 1.4-.6 2.3-1.9m-1 2.5Q28 25 28.8 24l-.2-.2q-.9 1.4-1 2.4m2.8-7.9-.3-.9a9 9 0 0 0-3-3v-.1h.1v-.4H27v-.1h-.3v.1h-.1v.4l-.2.6.3-.3v.5h.1v.2l.2-.1v.2-.2l.1.3.1-.2v.3l.2-.2v.3l.1-.1v.2h.2v.2l.1-.2v.3l.1-.2v.2l.2-.2.1.3.1-.2.3.4v-.3.3l.1-.3.1.4v-.2q2.2 2.2.3 5.1.6-.6 1-1.4-.4 1-1 1.9.6-.6.9-1.3-.5 1.5-1.4 2.7l.4.4.2-.5a6 6 0 0 0 1.2-4.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eac102",
    d: "M26.5 14.2h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a08307",
    d: "M26.4 14.3h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M26.8 14.2h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34541f",
    d: "M27.6 26.2q0-.6.5-1.2l.4-.9.2-.2-.2.2zm-1.3-.7q1.2-.5 2-1.6l-.8.8q-.5.6-1.2.8m2.5-2 .2-.2.4-.7.2-.5.3-.5-.2.2v.3zm.4-1.7.6-1 .4-1.3q0 .8-.4 1.3zm-.2-.4.7-.9.3-.7v-1.3l.1.5v.7H30l-.6 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34541f",
    d: "m28.7 23.4.2-.4.2-.1v-.2l.3-.4.2-.4.3-.7a6 6 0 0 0 .2-3.3q.3.7.2 1.6a6 6 0 0 1-.7 2.4l-.2.4-.2.4-.1.2-.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34541f",
    d: "m28.9 23.6.9-1.6a6 6 0 0 0 .5-3.6v.9l-.2 1.8-.3.9zm-1.9-9h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#448127",
    d: "m28.1 15.3.3.3-.5-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34541f",
    d: "m28.1 15.3.3.3-.3-.1-.2-.2.4.2h.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#448127",
    d: "m27.7 15.2.5.4-.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34541f",
    d: "m27.7 15.2.2.2.2.1h.1l-.1-.1-.2-.2.2.2.1.2-.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#448127",
    d: "m27.8 15 .4.4-.6-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34541f",
    d: "m27.8 15 .2.2h.1v.2zl.5.3-.1-.1v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#448127",
    d: "m27.5 15.3.5.3-.3-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34541f",
    d: "m27.5 15.3.5.3-.3-.3.3.2h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#448127",
    d: "m27.5 15.4.3.2-.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34541f",
    d: "m27.5 15.4.2.1h.1l-.3-.3.3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#448127",
    d: "m27.3 15 .6.5-.5-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34541f",
    d: "M27.3 15q.3 0 .5.4h.1l-.5-.2.5.2-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M24.6 24.8q-.6.4-1.3.4 1.1-.8 1.3-.4m4.8.3c.3.4 1.4.6 1.5.6q-1.2-1.1-1.5-.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#67923d",
    d: "M24.6 24.8q-.2-.4-1.3.4zm4.8.3c0-.3.8-.2 1.5.6z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1.11558 0 0 1.1363 24.8 20.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f9f0aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b07e09"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.73696 0 0 .75065 25 20.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f9f0aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b07e09"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.66259 0 0 .6749 25.3 20.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f9f0aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b07e09"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1.17643 0 0 1.19828 25.5 20.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f9f0aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b07e09"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.87894 0 0 .89527 24.7 16.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f9f0aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b07e09"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.02028 0 0 .02066 26.9 14.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#a50a0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c0505"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 26.6,
    x2: 26.5,
    y1: 17.2,
    y2: 15.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#b07e09",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b07e09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 27.2,
    x2: 27.4,
    y1: 19.8,
    y2: 21.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#b07e09",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b07e09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 25.1,
    x2: 25.3,
    y1: 16.5,
    y2: 15.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f9f0aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b07e09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 26.6,
    x2: 26.7,
    y1: 15.7,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f9f0aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b07e09"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGt);
export default __webpack_public_path__ + "static/media/gt.f566af508989970472fd743e391ccd82.svg";
export { ForwardRef as ReactComponent };